import { agentAvatar, agentDisplayName } from '@/config/env'
import { useConversationContext } from '@/contexts/ConversationContext'

export function EmptyState() {
  const { agentId } = useConversationContext()
  const displayName = agentDisplayName(agentId)

  return (
    <div className="flex flex-col items-center text-center">
      <div className="agent-avatar-bg size-30 rounded-full overflow-hidden flex items-center justify-center mb-8">
        <img
          src={agentAvatar(agentId)}
          alt={displayName}
          className="size-full object-cover"
        />
      </div>
      <h3 className="text-xl font-bold text-foreground mb-3">
        How can I help you today?
      </h3>
      <p className="text-base text-foreground/45">
        Ask {displayName} anything about your data
      </p>
    </div>
  )
}
